<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>Report Bulanan Helpdesk</h3>
        </b-col>
      </b-row>

      <div class="from-group row">
        <label for="" class="col-sm-2 col-form-label font-weight-bold"
          >Name</label
        >
        <div class="col-sm-6">
          <Select2 v-model="myValue" :settings="setting" :options="list" />
          <span class="text-danger" v-if="!myValue && isSubmit">
            Please Select User
          </span>
        </div>
      </div>
      <div class="from-group row">
        <label for="" class="col-sm-2 col-form-label font-weight-bold"
          >Date</label
        >
        <div class="col-sm-6">
          <date-picker
            v-model="date"
            lang="en"
            format="MMMM YYYY"
            type="month"
          ></date-picker>
        </div>
      </div>
      <div>
        <button class="btn btn-primary" @click="submit">Submit</button>
      </div>
      <br />
      <br />
      <b-row>
        <b-col md="12">
          <template v-if="show">
            <div class="table-responsive">
              <table class="table table-bordered bordertableResponsive">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Kategori Penilaian</th>
                    <th>Indikator Penilaian</th>
                    <th>Keterangan</th>
                    <th class="point">Point</th>
                    <th class="point">Nilai</th>
                    <th>Note</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(data, i) in report1">
                    <!-- Yang mempunyai indicator 1 dan child nya tidak ada-->
                    <template
                      v-if="
                        data.indicator.length == 1 &&
                          data.indicator[0].child.length == 0
                      "
                    >
                      <tr>
                        <td class="number">{{ i + 1 }}</td>
                        <td class="penilaian">{{ data.category }}</td>
                        <td class="indicator">{{ data.indicator[0].name }}</td>
                        <td class="keterangan">
                          {{ data.indicator[0].keterangan }}
                        </td>
                        <td class="point">{{ data.indicator[0].point }}</td>
                        <template v-if="data.indicator[0].editable">
                          <td class="point">
                            {{ data.indicator[0].nilai || 0 }}
                          </td>
                          <td class="note">{{ data.indicator[0].note }}</td>
                          <td><i class="fa fa-pencil text-success"></i></td>
                        </template>
                        <template v-else>
                          <td class="point">
                            {{ data.indicator[0].nilai || 0 }}
                          </td>
                          <td class="note">{{ data.indicator[0].note }}</td>
                          <td></td>
                        </template>
                      </tr>
                    </template>
                    <!--yang mempunyai indicator lebih dari 1 atau dalam indicator memiliki child-->
                    <template v-else>
                      <tr>
                        <td class="number" :rowspan="data.total_row">
                          {{ i + 1 }}
                        </td>
                        <td class="penilaian" :rowspan="data.total_row">
                          {{ data.category }}
                        </td>
                        <td class="indikator">{{ data.indicator[0].name }}</td>
                        <td class="keterangan">
                          {{ data.indicator[0].keterangan }}
                        </td>
                        <td class="point">{{ data.indicator[0].point }}</td>
                        <template v-if="data.indicator[0].editable">
                          <td v-bind:id="'point-' + i" class="point">
                            {{ data.indicator[0].nilai || 0 }}
                          </td>
                          <!--pembantu untuk old point-->
                          <span v-bind:id="'point-old-' + i" v-show="false">
                            {{ data.indicator[0].nilai || 0 }}
                          </span>
                          <span v-bind:id="'note-old-' + i" v-show="false">
                            {{ data.indicator[0].note }}
                          </span>
                          <td class="note" v-bind:id="'note-' + i">
                            {{ data.indicator[0].note }}
                          </td>
                          <td>
                            <span>
                              <template v-if="!edit[i]">
                                <i
                                  class="fa fa-pencil text-success"
                                  @click="showEditable(i, false)"
                                ></i>
                              </template>
                              <template v-else>
                                <i
                                  class="fa fa-save text-success"
                                  @click="
                                    saveEditable(i, false, data.indicator[0].id)
                                  "
                                ></i>
                                <i
                                  class="fa fa-times text-danger"
                                  @click="cancelEditable(i, false)"
                                ></i>
                              </template>
                            </span>
                          </td>
                        </template>
                        <template v-else>
                          <td class="point">
                            {{ data.indicator[0].nilai || 0 }}
                          </td>
                          <td class="note">{{ data.indicator[0].note }}</td>
                          <td></td>
                        </template>
                      </tr>
                      <!--yang mempunyai child pada indicator-->
                      <template v-for="(indicator, j) in data.indicator">
                        <template v-if="j > 0">
                          <tr>
                            <td class="indicator">{{ indicator.name }}</td>
                            <td class="keterangan">
                              {{ indicator.keterangan }}
                            </td>
                            <td
                              class="point"
                              :rowspan="indicator.child.length + 1"
                              style="vertical-align: middle"
                            >
                              {{ indicator.point }}
                            </td>
                            <template v-if="data.indicator[0].editable">
                              <!-- bagian ke dalam td child-->
                              <!--v-on:keydown="testCharacter(indicator.id,'sisdur', $event)"-->
                              <!--@click="content('sisdur')"-->
                              <td
                                :rowspan="indicator.child.length + 1"
                                style="vertical-align: middle"
                                v-bind:id="'child-point-' + i"
                                class="point"
                              >
                                {{ indicator.nilai || 0 }}
                              </td>
                              <!--pembantu untuk  child old point-->
                              <span
                                v-bind:id="'child-point-old-' + i"
                                v-show="false"
                              >
                                {{ indicator.nilai || 0 }}
                              </span>
                              <span
                                v-bind:id="'child-note-old-' + i"
                                v-show="false"
                              >
                                {{ indicator.note }}
                              </span>

                              <td
                                class="note"
                                :rowspan="indicator.child.length + 1"
                                style="vertical-align: middle"
                                v-bind:id="'child-note-' + i"
                              >
                                {{ indicator.note }}
                              </td>
                              <td :rowspan="indicator.child.length + 1">
                                <span>
                                  <template v-if="!childEdit">
                                    <i
                                      class="fa fa-pencil text-success"
                                      @click="showEditable(i, true)"
                                    ></i>
                                  </template>
                                  <template v-else>
                                    <i
                                      class="fa fa-save text-success"
                                      @click="
                                        saveEditable(i, true, indicator.id)
                                      "
                                    ></i>
                                    <i
                                      class="fa fa-times text-danger"
                                      @click="cancelEditable(i, true)"
                                    ></i>
                                  </template>
                                </span>
                              </td>
                            </template>
                            <template v-else>
                              <td
                                :rowspan="indicator.child.length + 1"
                                style="vertical-align: middle"
                                class="point"
                              >
                                {{ indicator.nilai || 0 }}
                              </td>
                              <td
                                class="note"
                                :rowspan="indicator.child.length + 1"
                                style="vertical-align: middle"
                              >
                                <div>
                                  {{ indicator.note }}
                                </div>
                              </td>
                              <td :rowspan="indicator.child.length + 1"></td>
                            </template>
                          </tr>
                        </template>
                        <template v-if="indicator.child.length > 0">
                          <template v-for="child in indicator.child">
                            <tr>
                              <td class="indicator">{{ child.label }}</td>
                              <td class="keterangan">{{ child.keterangan }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>
                  <tr>
                    <td colspan="4"></td>
                    <td>Total</td>
                    <td class="point">{{ total_nilai }}</td>
                    <td colspan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-button v-b-toggle.history variant="primary" @click="showHistory"
              >Show History</b-button
            >
            <div class="History">
              <b-collapse id="history" class="mt-2">
                <div style="text-align: center" v-if="!loadingHistory">
                  <pulse-loader :size="'12px'"></pulse-loader>
                </div>
                <div v-if="loadingHistory">
                  <template v-if="historyEditHelpdesk.length > 0">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th class="HistoryNo">No</th>
                          <th class="HistoryDate">Date / Time</th>
                          <th>Description</th>
                          <th class="HistoryEdit">Changed</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(history, i) in historyEditHelpdesk">
                          <td>{{ i + 1 }}</td>
                          <td>{{ history.date | plusEnter }}</td>
                          <td>
                            <b>{{ history.activity_name }}</b> &nbsp;{{
                              history.indicator
                            }}<br />
                            <template
                              v-if="
                                history.change_data_detail.old.point_result ||
                                  history.change_data_detail.new.point_result
                              "
                            >
                              POINT :
                              <template
                                v-if="
                                  history.change_data_detail.old.point_result
                                "
                              >
                                <del>{{ history.old_data.point_result }}</del>
                              </template>
                              <template v-else>
                                <b>New</b>
                              </template>
                              &#8594;
                              {{ history.change_data_detail.new.point_result }}
                            </template>
                            <br />
                            <template
                              v-if="
                                history.old_data.note || history.new_data.note
                              "
                            >
                              NOTE :
                              <template
                                v-if="history.change_data_detail.old.note"
                              >
                                <del>{{ history.old_data.note }}</del>
                              </template>
                              <template v-else>
                                <b>New</b>
                              </template>
                              &#8594; {{ history.new_data.note }}
                            </template>
                          </td>
                          <td>{{ history.change_by }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <template v-else>
                    <div class="alert alert-warning">
                      No Have History Edit
                    </div>
                  </template>
                </div>
              </b-collapse>
            </div>
          </template>
        </b-col>
      </b-row>

      <!-- <b-row>
         <b-col md="12">
           <table class="table table-bordered">
             <thead>
             <tr>
               <th>Indikator Penilaian</th>
               <th>Keterangan</th>
               <th>Point</th>
               <th>Nilai</th>
             </tr>
             </thead>
               <template v-for="data in report1">
                 <tr>
                   <td colspan="4" class="bg-info">{{data.category}}</td>
                 </tr>
                 <template v-for="indikator in data.indikator">
                   <tr>
                     <td>{{indikator.name}}</td>
                     <td>{{indikator.keterangan}}</td>
                     <td :rowspan="indikator.child.length == 0 ? 1: 2 " style="vertical-align: middle; text-align: center;">{{indikator.point}}</td>
                     <td :rowspan="indikator.child.length == 0 ? 1: 2 " style="vertical-align: middle; text-align: center;">{{indikator.nilai}} </td>
                   </tr>
                   <template v-if="indikator.child.length > 0">
                     <tr>
                       <td>
                           <ul>
                             <li v-for="child in indikator.child">{{child.label}}</li>
                           </ul>
                       </td>
                       <td>
                         <ul>
                           <li v-for="child in indikator.child">{{child.keterangan}}</li>
                         </ul>
                       </td>
                     </tr>
                   </template>
                 </template>
               </template>
             <tr>
               <td colspan="3" align="center"> Total</td>
               <td>85.6</td>
             </tr>
           </table>
         </b-col>
       </b-row>-->
    </b-card>
  </div>
</template>

<script>
import { getService, postService } from "../../services";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    DatePicker,
    PulseLoader
  },
  name: "reporthelpdesk",
  data() {
    return {
      report1: [],
      date: Date.now(),
      edit: [],
      childEdit: false,
      show: false,
      total_nilai: 0,
      myValue: "",
      setting: {
        width: "100%"
      },
      list: [],
      loadingHistory: false,
      historyEditHelpdesk: [],
      isSubmit: false
    };
  },
  beforeRouteUpdate(to, from, next) {
    var date;
    if (to.query.date) {
      this.myValue = to.query.id;
      date = moment(to.query.date, "x").format("YYYY-MM");
      this.date = date;
      this.getData(this.myValue, date);
    }
    next();
  },
  created: function() {
    this.getEmployee();
  },
  mounted: function() {
    var date;
    if (this.$route.query.date) {
      this.myValue = this.$route.query.id;
      date = moment(this.$route.query.date, "x").format("YYYY-MM");
      this.date = date;
      this.getData(this.myValue, date);
    }
  },
  methods: {
    showEditable: function(i, child) {
      var nilai, note;
      if (child) {
        nilai = "child-point-" + i;
        note = "child-note-" + i;
        this.childEdit = true;
      } else {
        nilai = "point-" + i;
        note = "note-" + i;
        Vue.set(this.edit, i, true);
      }
      var contentNilai = document.getElementById(nilai);
      contentNilai.contentEditable = true;
      contentNilai.onkeypress = function(evt) {
        if (evt.keyCode == 46) return true;
        if (evt.keyCode < 48 || evt.keyCode > 57) return false;
      };
      document.getElementById(note).contentEditable = true;
    },
    saveEditable: function(i, child, indicator) {
      var nilai, note, nilai_old, note_old;
      if (child) {
        nilai = "child-point-" + i;
        note = "child-note-" + i;
        nilai_old = "child-point-old-" + i;
        note_old = "child-note-old-" + i;
        this.childEdit = false;
      } else {
        nilai = "point-" + i;
        note = "note-" + i;
        nilai_old = "point-old-" + i;
        note_old = "note-old-" + i;
        Vue.set(this.edit, i, false);
      }
      document.getElementById(nilai).contentEditable = false;
      document.getElementById(note).contentEditable = false;
      var point = document.getElementById(nilai).innerText;
      var note = document.getElementById(note).innerText;
      this.sendEditHistory(
        indicator,
        this.myValue,
        this.date,
        point.trim(),
        note
      );
      this.total_nilai =
        this.total_nilai +
        Number(document.getElementById(nilai).innerText) -
        Number(document.getElementById(nilai_old).innerText);
      document.getElementById(nilai_old).innerText = document.getElementById(
        nilai
      ).innerText;
      // console.log(indicator, this.myValue, this.date, point.trim(), note)
    },
    cancelEditable: function(i, child) {
      var nilai, note, nilai_old, note_old;
      if (child) {
        nilai = "child-point-" + i;
        note = "child-note-" + i;
        nilai_old = "child-point-old-" + i;
        note_old = "child-note-old-" + i;
        this.childEdit = false;
      } else {
        nilai = "point-" + i;
        note = "note-" + i;
        nilai_old = "point-old-" + i;
        note_old = "note-old-" + i;
        Vue.set(this.edit, i, false);
      }
      document.getElementById(nilai).contentEditable = false;
      document.getElementById(note).contentEditable = false;
      var oke = document.getElementById(nilai_old).innerText;
      var test = document.getElementById(note_old).innerText;
      document.getElementById(nilai).innerText = oke.trim();
      // document.getElementById(note).innerText = document.getElementById(note_old).innerText
    },
    testCharacter: function(id, element, event) {
      if ((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 8) {
        return true;
      } else if (event.keyCode === 13) {
        document.getElementById(element).contentEditable = false;
        let date = moment(this.date).format("YYYY-MM");
        let point = document.getElementById(element).innerText;
        postService
          .post_point_helpdesk(id, this.myValue, date, Number(point), "")
          .then(data => {
            //action change total nilai
            let old = element + "-old";
            this.total_nilai =
              this.total_nilai +
              Number(document.getElementById(element).innerText) -
              Number(document.getElementById(old).innerText);
            document.getElementById(old).innerText = document.getElementById(
              element
            ).innerText;
          });
      } else {
        event.preventDefault();
        return false;
      }
    },
    content(id) {
      document.getElementById(id).contentEditable = true;
    },
    getData: function(id, date) {
      this.getReportHelpdesk(id, date);
    },
    getReportHelpdesk(id, date) {
      this.$store.commit("noLoad", true);
      getService.list_report_helpdesk(id, date).then(data => {
        this.loadingHistory = false;
        this.$store.commit("noLoad", false);
        this.total_nilai = data.total_nilai;
        this.show = true;
        this.$store.commit("noLoad", false);
        this.report1 = data.data;
        for (let i = 0; i < this.report1.length; i++) {
          this.edit[i] = false;
        }
      });
    },
    getEmployee: function() {
      getService.list_employee().then(employee => {
        var ary = [];
        this.employee = employee;
        for (let i = 0; i < employee.length; i++) {
          const obj = {
            id: employee[i].EmpId,
            text: employee[i].EmpFName + " " + employee[i].EmpLName
          };
          ary.push(obj);
        }
        this.list = ary;
      });
    },
    sendEditHistory(id, user_id, date, point, note) {
      postService
        .post_point_helpdesk(id, user_id, date, point, note)
        .then(data => {
          //action change total nilai
          this.loadingHistory = false;
        });
    },
    getHistoryHelpdesk(user, date) {
      getService.list_history_edit_helpdesk(user, date).then(data => {
        this.loadingHistory = true;
        var historyOld = [];
        for (let i = data.length - 1; i >= 0; i--) {
          historyOld.push(data[i]);
        }
        this.historyEditHelpdesk = historyOld;
      });
    },
    submit() {
      this.isSubmit = true;
      if (!this.myValue) {
        return false;
      }
      let date;
      if (typeof this.date == "number") {
        date = this.date;
      } else {
        date = moment(this.date, "MMMM YYYY").format("x");
      }
      this.$router.replace({
        name: "Best Monthly",
        query: {
          id: this.myValue,
          date: date
        }
      });
    },
    showHistory() {
      if (!this.loadingHistory) {
        let id = this.$route.query.id;
        let date = moment(this.$route.query.date, "x").format("YYYY-MM");
        this.getHistoryHelpdesk(id, date);
        // action tarik nya
      }
    }
  },
  filters: {
    plusEnter: function(date) {
      return date.replace(" ", "\n");
    }
  }
};
</script>

<style scoped>
#sisdur:hover:after,
#komunikasi:hover:after {
  content: "edit";
  color: #ccc;
  position: sticky;
  vertical-align: text-top;
}

.number {
  min-width: 47px;
  text-align: right;
}

.penilaian {
  min-width: 190px;
}

.indikator {
  min-width: 440px;
}

.keterangan {
  min-width: 175px;
}

.point {
  text-align: center;
}

.note {
  min-width: 200px;
}

.HistoryNo {
  width: 50px;
}
.HistoryDate {
  width: 150px;
}
.HistoryEdit {
  width: 250px;
}
.History {
  width: 80%;
}
@media only screen and (max-width: 980px) {
  .History {
    width: 100%;
  }
}
</style>
